import { Injector } from "@angular/core";

export const AppConstants = {
  urls: {
    app: {
      login: "login",
    },
    api: {
      //base: "http://95.217.230.136:4321/ut/api/",
      //base: 'https://uatu.edu-man.com/ut/api/',
      base: 'https://utp.edu-man.com/ut/api/',
      //base: 'http://demo.kcompute.com:9014/ut/api/',

      application: "",
      reportNGUrl: "",
      reportUrl: "",
    },
  },
  settings: {
    version: "1.0.0.12",
    appCode: "UT",
    instanceid: 22,
    instancecode: "UT002",
    dateFormat: "dd-MMM-yyyy",
    timeFormat: "HH:mm",
    dateFormatforString: "DD-MMM-YYYY",
    timeFormatforString: "hh:mm:ss A",
    timeFormatTile: "hh:mm A",
    dateAndTime: "YYYY-MM-DDTHH:mm",
  },
  policy: {
    dateFormat: "",
    timeFormat: "",
    gridpagging: false,
    defaultcityid: 0,
    defaultctryid: 0,
    defaultstateid: 0,
  },
  injector: <Injector>{},
};



// WEBPACK FOOTER //
// ./src/app/app.constant.ts